import {
  buildExpenseFeeCategoryFromSupplier as buildFeeCategoryFromSupplier,
  buildExpenseFeeClassFromSupplier as buildFeeClassFromSupplier,
} from '@/composables/expensesFees/shared/useExpenseFeeSupplierFlow';
import {
  resetExpenseFeeTaxSelection as resetFeeTaxSelection,
  resolveExpenseFeeVoucherFlags as resolveFeeVoucherFlags,
} from '@/composables/expensesFees/shared/useExpenseFeeTaxFlow';

export const applyFeeCommissionTypeRules = (form = {}, nextType = '') => {
  const normalized = String(nextType || 'collaborator').trim().toLowerCase();

  if (normalized === 'collaborator') {
    form.supplier = null;
    form.supplierContributor = null;
    return { usesSupplier: false };
  }

  form.collaborator = null;
  return { usesSupplier: true };
};

export const applyFeeVoucherTypeRules = (form = {}, voucherType = '') => {
  const flags = resolveFeeVoucherFlags(voucherType);

  if (flags.isSimpleNoteVoucher || flags.isPayrollVoucher) {
    resetFeeTaxSelection(form);
    form.withoutTaxes = false;
  }

  if (flags.isSimpleNoteVoucher || flags.isForeignReceiptVoucher) {
    form.supplierContributor = null;
    form.cfdiDate = null;
  }

  if (flags.isPayrollVoucher) {
    form.discount = 0;
  } else {
    form.deductions = 0;
  }
};

export const applyFeeWithoutTaxesRules = (form = {}, withoutTaxesEnabled = false) => {
  if (!withoutTaxesEnabled) {
    return;
  }

  resetFeeTaxSelection(form);
};

export const applyFeeSupplierAutoFillFromSupplier = (
  form = {},
  supplierOption = null,
  resolveOptionId = () => 0
) => {
  const classOption = buildFeeClassFromSupplier(supplierOption);
  const categoryOption = buildFeeCategoryFromSupplier(supplierOption);

  if (classOption && resolveOptionId(form?.expenseClass) <= 0) {
    form.expenseClass = classOption;
  }

  if (categoryOption && resolveOptionId(form?.expenseCategory) <= 0) {
    form.expenseCategory = categoryOption;
  }
};
